/* ==========================================
   HEAL N PRETTY — THEME JS
   Apple-style scroll animations + UX
   ========================================== */
(function(){var box=document.getElementById('hnpAddons');if(!box){return;}var money=function(n){return '$'+Number(n).toFixed(2);};var esc=function(s){return String(s).replace(/[&<>"]/g,function(c){return '&#'+c.charCodeAt(0)+';';});};var json=function(u){return fetch(u,{headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():{products:[]};}).catch(function(){return {products:[]};});};Promise.all([json('/cart.js'),json('/collections/add-ons/products.json?limit=50')]).then(function(res){var cart=res[0];var list=res[1].products||[];if(!list.length){return json('/products.json?limit=250').then(function(all){return [cart,(all.products||[]).filter(function(p){return !/recovery kit|ebook|guide/i.test(p.title);})];});}return [cart,list];}).then(function(d){var cart=d[0];var inCart={};(cart.items||[]).forEach(function(i){inCart[i.product_id]=true;});var items=d[1].filter(function(p){return !inCart[p.id]&&p.variants.some(function(v){return v.available;});});if(!items.length){return;}var html='<h2 style="margin:0 0 4px;font-size:1.5rem;color:var(--color-secondary);">Add to your order</h2><p style="margin:0 0 var(--spacing-md);color:var(--hnp-muted);">Hey Hottie, a few favorites to make healing even easier.</p><div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:14px;">';items.forEach(function(p){var vs=p.variants.filter(function(v){return v.available;});var img=p.images&&p.images[0]?p.images[0].src.replace(/(\.[a-zA-Z]+)(\?|$)/,'_400x$1$2'):'';var sel='';if(vs.length>1){sel='<select data-sel style="width:100%;padding:8px;border:1px solid var(--color-border);border-radius:8px;margin-bottom:8px;">'+vs.map(function(v){return '<option value="'+v.id+'">'+esc(v.title)+' ('+money(v.price)+')</option>';}).join('')+'</select>';}html+='<div style="border:1px solid var(--color-border);border-radius:12px;padding:12px;display:flex;flex-direction:column;"><a href="/products/'+p.handle+'" style="text-decoration:none;color:inherit;">'+(img?'<img src="'+img+'" alt="'+esc(p.title)+'" loading="lazy" style="width:100%;height:150px;object-fit:cover;border-radius:8px;margin-bottom:8px;">':'')+'<div style="font-weight:700;margin-bottom:2px;">'+esc(p.title)+'</div></a><div style="color:var(--hnp-muted);margin-bottom:8px;">'+(vs.length>1?'From ':'')+money(Math.min.apply(null,vs.map(function(v){return Number(v.price);})))+'</div><div style="margin-top:auto;">'+sel+'<button type="button" data-add="'+vs[0].id+'" style="width:100%;padding:10px;border:0;border-radius:999px;background:var(--hnp-mauve);color:#fff;font-weight:700;cursor:pointer;">Add to order</button></div></div>';});html+='</div>';box.innerHTML=html;box.style.display='block';box.addEventListener('click',function(e){var b=e.target.closest('[data-add]');if(!b){return;}var s=b.parentNode.querySelector('[data-sel]');var id=s?s.value:b.getAttribute('data-add');b.disabled=true;b.textContent='Adding...';fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})}).then(function(r){if(!r.ok){throw new Error('add failed');}window.location.reload();}).catch(function(){b.disabled=false;b.textContent='Try again';});});});})();
(function () {
  'use strict';

  /* ---- 1. SCROLL-SHRINK HEADER ---- */
  const header = document.querySelector('header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- 2. MOBILE NAV ---- */
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      const open = hamburger.classList.toggle('open');
      mobileNav.classList.toggle('open', open);
      hamburger.setAttribute('aria-expanded', String(open));
    });
    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        hamburger.classList.remove('open');
        mobileNav.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---- 3. APPLE-STYLE SCROLL REVEAL (IntersectionObserver) ---- */
  function initScrollReveal() {
    const targets = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale, [data-reveal]');
    if (!targets.length) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    targets.forEach(el => io.observe(el));
  }

  /* ---- 4. AUTO-APPLY REVEAL CLASSES TO COMMON ELEMENTS ---- */
  function autoReveal() {
    const sectionHeaders = document.querySelectorAll('.section-header, .eyebrow');
    sectionHeaders.forEach(el => el.classList.add('reveal'));

    const cards = document.querySelectorAll('.card, .testimonial');
    cards.forEach((el, i) => {
      el.classList.add('reveal');
      const delay = i % 4;
      if (delay > 0) el.classList.add('stagger-' + delay);
    });

    const trustItems = document.querySelectorAll('.trust-item');
    trustItems.forEach((el, i) => {
      el.classList.add('reveal');
      if (i > 0) el.classList.add('stagger-' + Math.min(i, 5));
    });

    const heroText = document.querySelector('.hero-text');
    const heroImg  = document.querySelector('.hero-img-wrap');
    if (heroText) heroText.classList.add('reveal-left');
    if (heroImg)  heroImg.classList.add('reveal-right');

    const newsletterStrip = document.querySelector('.newsletter-strip');
    if (newsletterStrip) newsletterStrip.classList.add('reveal-scale');
  }

  /* ---- 5. ANIMATED STAT COUNTER ---- */
  function initCounters() {
    const nums = document.querySelectorAll('.trust-number[data-count]');
    if (!nums.length) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el     = entry.target;
        const target = parseFloat(el.dataset.count);
        const suffix = el.dataset.suffix || '';
        const prefix = el.dataset.prefix || '';
        const dur    = 1800;
        const start  = performance.now();

        const tick = (now) => {
          const p = Math.min((now - start) / dur, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          const val   = target < 100 ? (eased * target).toFixed(1) : Math.round(eased * target).toLocaleString();
          el.textContent = prefix + val + suffix;
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });

    nums.forEach(n => io.observe(n));
  }

  /* ---- 6. CART COUNT ---- */
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(d => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = d.item_count;
          el.classList.remove('bump');
          void el.offsetWidth;
          el.classList.add('bump');
          setTimeout(() => el.classList.remove('bump'), 400);
        });
      })
      .catch(() => {});
  }

  /* ---- 7. CART DRAWER ---- */
  function buildCartDrawerHTML() {
    var checkoutHref = window.location.pathname.indexOf('/collections/add-ons') !== -1 ? '/checkout' : '/collections/add-ons';
    return `
      <div class="cart-overlay" id="cartOverlay"></div>
      <aside class="cart-drawer" id="cartDrawer" role="dialog" aria-modal="true" aria-label="Shopping bag">
        <div class="cart-drawer-header">
          <h3>Your Bag ♥</h3>
          <button class="cart-drawer-close" id="cartClose" aria-label="Close bag">&times;</button>
        </div>
        <div class="cart-drawer-body" id="cartDrawerBody">
          <p class="cart-empty-msg">Your bag is empty.</p>
        </div>
        <div class="cart-drawer-footer" id="cartDrawerFooter" style="display:none;">
          <div style="display:flex;justify-content:space-between;margin-bottom:1rem;font-weight:700;color:var(--hnp-plum);font-size:1.1rem;">
            <span>Total</span><span id="cartTotal"></span>
          </div>
          <a href="${checkoutHref}" class="btn btn--primary btn--full">Checkout</a>
          <a href="/cart" style="display:block;text-align:center;margin-top:0.75rem;font-size:0.85rem;color:var(--hnp-muted);">View full bag</a>
        </div>
      </aside>
    `;
  }

  function initCartDrawer() {
    document.body.insertAdjacentHTML('beforeend', buildCartDrawerHTML());
    const overlay   = document.getElementById('cartOverlay');
    const drawer    = document.getElementById('cartDrawer');
    const closeBtn  = document.getElementById('cartClose');
    const body      = document.getElementById('cartDrawerBody');
    const footer    = document.getElementById('cartDrawerFooter');
    const totalEl   = document.getElementById('cartTotal');

    function fmt(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function openDrawer() {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          if (cart.item_count === 0) {
            body.innerHTML = '<p class="cart-empty-msg">♥ Your bag is empty.</p>';
            footer.style.display = 'none';
          } else {
            body.innerHTML = cart.items.map(item => `
              <div class="cart-line" data-key="${item.key}">
                <img src="${item.image}" alt="${item.title}">
                <div class="cart-line-info">
                  <div class="cart-line-title">${item.title}</div>
                  <div class="cart-line-price">${fmt(item.final_line_price)}</div>
                  <div style="font-size:0.8rem;color:var(--hnp-muted);">×${item.quantity}</div>
                </div>
              <button class="cart-line-remove" data-key="${item.key}" aria-label="Remove ${item.title}">&times;</button>
              </div>
            `).join('');
            totalEl.textContent = fmt(cart.total_price);
            footer.style.display = 'block';
          }
          overlay.classList.add('active');
          drawer.classList.add('active');
          document.body.style.overflow = 'hidden';
        })
        .catch(() => {});
    }

    function closeDrawer() {
      overlay.classList.remove('active');
      drawer.classList.remove('active');
      document.body.style.overflow = '';
    }
  body.addEventListener('click', e => {
    const removeBtn = e.target.closest('.cart-line-remove');
    if (!removeBtn) return;
    const key = removeBtn.dataset.key;
    removeBtn.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(r => r.json())
      .then(() => {
        updateCartCount();
        openDrawer();
      })
      .catch(() => {
        removeBtn.disabled = false;
        showToast('Something went wrong. Please try again.', 'error');
      });
  });
    document.querySelectorAll('.cart-link').forEach(el => {
      el.addEventListener('click', e => { e.preventDefault(); openDrawer(); });
    });
    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

    window._openCartDrawer = openDrawer;
  }

  /* ---- 8. ADD TO CART WITH DRAWER ---- */
  function initAddToCart() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function(e) {
    e.preventDefault();

    const requiredFields = form.querySelectorAll('.kit-size-required');
    for (const field of requiredFields) {
    if (!field.value) {
    field.focus();
    showToast('Please select a size for all required options.', 'error');
    return;
    }
    }

    const btn = form.querySelector('[type="submit"]');
    const orig = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    const properties = {};
    form.querySelectorAll('[name^="properties["]').forEach(field => {
    const match = field.name.match(/^properties\[(.+)\]$/);
    if (match) { properties[match[1]] = field.value; }
    });

    const body = {
    id: form.querySelector('[name="id"]').value,
    quantity: parseInt(form.querySelector('[name="quantity"]')?.value || '1')
    };
    if (Object.keys(properties).length) { body.properties = properties; }

    fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
    })
    .then(r => r.json())
    .then(() => {
    updateCartCount();
    showToast('Added to bag ♥');
    if (btn) { btn.textContent = orig; btn.disabled = false; }
    if (window._openCartDrawer) window._openCartDrawer();
    })
    .catch(() => {
    showToast('Something went wrong. Please try again.', 'error');
    if (btn) { btn.textContent = orig; btn.disabled = false; }
    });
    });
    });
    }

  /* ---- 9. TOAST ---- */
  let toastEl = null;
  let toastTimer = null;
  function showToast(msg, type) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.style.background = type === 'error' ? '#B04060' : 'var(--hnp-plum)';
    clearTimeout(toastTimer);
    toastEl.classList.remove('show');
    void toastEl.offsetWidth;
    toastEl.classList.add('show');
    toastTimer = setTimeout(() => toastEl.classList.remove('show'), 3500);
  }

  /* ---- 10. QUANTITY BUTTONS ---- */
  function initQtyButtons() {
    document.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        const input  = this.closest('[data-qty-group]')?.querySelector('input[name="quantity"]')
                    || this.parentElement.querySelector('input[name="quantity"]');
        if (!input) return;
        const val = parseInt(input.value) || 1;
        input.value = this.dataset.action === 'increase' ? val + 1 : Math.max(1, val - 1);
      });
    });
  }

  /* ---- 11. PARALLAX ON HERO IMAGE ---- */
  function initParallax() {
    const heroImg = document.querySelector('.section--hero .hero-img');
    if (!heroImg || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY;
      heroImg.style.transform = `translateY(${scrolled * 0.12}px) scale(1.03)`;
    }, { passive: true });
  }

  /* ---- 12. SMOOTH SCROLL FOR ANCHORS ---- */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* ---- INIT ALL ---- */
  document.addEventListener('DOMContentLoaded', () => {
    autoReveal();
    initScrollReveal();
    initCounters();
    initCartDrawer();
    initAddToCart();
    initQtyButtons();
    initParallax();
    updateCartCount();
  });

})();
